import {ApiClient} from '@hconnect/apiclient'
import {useUpmPlantContext, useUpmPlantNow, type UpmPlant} from '@hconnect/upm'
import {useQuery} from '@tanstack/react-query'
import {AxiosError} from 'axios'

import {OPTIMIZER_SETTINGS_QUERY_KEY, getOptimizerSettingsPath} from '../consts'
import {mapOptimizerSettingsResponse} from '../selectors'
import {OptimizerSettings, OptimizerSettingsDTO} from '../types'

export const useOptimizerSettings = () => {
  const {plantId: plantCode}: UpmPlant = useUpmPlantContext()
  const getPlantNow = useUpmPlantNow()

  return useQuery<OptimizerSettingsDTO, AxiosError, OptimizerSettings>({
    queryKey: [OPTIMIZER_SETTINGS_QUERY_KEY, {plantCode}],
    queryFn: async ({signal}) => {
      const response = await ApiClient.axiosInstance.get<OptimizerSettingsDTO>(
        getOptimizerSettingsPath(plantCode),
        {signal}
      )
      return response.data
    },
    throwOnError: true,
    select: (response) => mapOptimizerSettingsResponse(response, getPlantNow())
  })
}
